// Contact page component
export function ContactPage() {
  return `

<div class="hero">
  <div class="hero-content">
    <h1 class="hero-title">Contacto</h1>
    <p class="hero-subtitle">¿Tiene alguna pregunta? Estamos aquí para ayudarle con su certificado CEE.</p>
  </div>
</div>
<section class="section bg-gray-50">
  <div class="container">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-1">

      
      <div class="card text-center">
        <div class="flex justify-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor"
            class="w-10 h-10 text-blue-600">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M2.25 3.75a.75.75 0 01.75-.75h2.25a.75.75 0 01.75.75v3.75a.75.75 0 01-.75.75H4.5v.75a12.75 12.75 0 0012.75 12.75h.75v-1.5a.75.75 0 01.75-.75h3.75a.75.75 0 01.75.75v2.25a.75.75 0 01-.75.75H18A15.75 15.75 0 012.25 6V3.75z" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-gray-900 mb-3">Teléfono</h3>
        <p class="text-2xl font-bold text-blue-600 mb-2">626 80 65 52</p>
        <p class="text-gray-600 text-sm">Lunes a viernes: 9:00 – 19:00</p>
        <p class="text-gray-600 text-sm">Sábado: 10:00 – 14:00</p>
        <p class="text-xs text-green-600 mt-2">Llamadas gratuitas desde cualquier operador</p>
      </div>

      
      <div class="card text-center">
        <div class="flex justify-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor"
            class="w-10 h-10 text-blue-600">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M21.75 6.75v10.5a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5V6.75m19.5 0L12 12.75 2.25 6.75" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-gray-900 mb-3">Correo electrónico</h3>
        <p class="text-lg font-semibold text-blue-600 mb-2">info@ceecasasespana.com</p>
        <p class="text-gray-600 text-sm">Respuesta garantizada en menos de 24 horas</p>
        <p class="text-xs text-gray-500 mt-2">Para consultas técnicas detalladas</p>
      </div>


      <div class="card text-center">
        <div class="flex justify-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor"
            class="w-10 h-10 text-green-600">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M10.5 1.5h3A2.25 2.25 0 0115.75 3.75v16.5A2.25 2.25 0 0113.5 22.5h-3A2.25 2.25 0 018.25 20.25V3.75A2.25 2.25 0 0110.5 1.5zM12 18h.008v.008H12V18z" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-gray-900 mb-3">WhatsApp</h3>
        <p class="text-lg font-semibold text-blue-600 mb-2">626 80 65 52</p>
        <p class="text-gray-600 text-sm">Respuesta inmediata</p>
        <p class="text-xs text-gray-500 mt-2">Para consultas rápidas</p>
      </div>
    </div>
  </div>



</section>
<section class="section bg-gray-50">
  <div class="container max-w-4xl mx-auto">
    <div class="bg-white rounded-lg shadow-lg p-8">
      <h2 class="text-3xl font-bold text-gray-900 text-center mb-8">
        Envíenos un mensaje
      </h2>


      <form id="contact-form" class="space-y-6">
        <!-- HONEYPOT FIELD -->
        <div style="position:absolute; left:-9999px; top:-9999px;">
          <input type="text" name="hp_field" tabindex="-1" autocomplete="off">
        </div>

        <!-- TIMESTAMP FIELD -->
        <input type="hidden" name="ts" id="ts">

        <div class="grid md:grid-cols-2 gap-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Nombre de la empresa
            </label>
            <input type="text" name="company"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Nombre *
            </label>
            <input type="text" name="firstname" required
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Apellido *
            </label>
            <input type="text" name="lastname" required
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
          </div>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Correo electrónico *
          </label>
          <input type="email" name="email" required
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Teléfono *
          </label>
          <input type="tel" name="phone" required
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Mensaje *
          </label>
          <textarea name="message" rows="5" required
            placeholder="¿En qué podemos ayudarle?"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 resize-vertical"></textarea>
        </div>

        <div class="flex items-start">
          <input type="checkbox" name="privacy" required class="mt-1 mr-3">
          <label class="text-sm text-gray-600">
            He leído y acepto la
            <a href="/privacy/" target="_blank" class="text-blue-600 hover:underline">
              política de privacidad
            </a> *
          </label>
        </div>

        <button type="submit" class="btn btn-primary">
          Enviar mensaje
        </button>
      </form>
    </div>
  </div>
</section>

  `;
} 

export function initializeContactForm(API_BASE) {
  const form = document.getElementById("contact-form");
  if (!form) {
    setTimeout(() => initializeContactForm(API_BASE), 100);
    return;
  }

  const tsField = form.querySelector('input[name="ts"]');
  if (tsField) tsField.value = Date.now();

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    console.log("🟢 CONTACT FORM SUBMITTED");

    const data = Object.fromEntries(new FormData(form));

    try {
      const response = await fetch(`${API_BASE}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Error del servidor: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        alert("¡Gracias por su mensaje! Nos pondremos en contacto con usted lo antes posible.");
        form.reset();
        if (tsField) tsField.value = Date.now();
      } else {
        alert("Ha ocurrido un error al enviar el formulario.");
        console.error("❌ Backend error:", result.error);
      }
    } catch (err) {
      console.error("❌ Error al enviar:", err);
      alert("Ha ocurrido un error al enviar el formulario.");
    }
  });
}
